import { UnfoldLess as UnfoldLessIcon } from "@mui/icons-material";
import { UnfoldMore as UnfoldMoreIcon } from "@mui/icons-material";
import { VisibilityOffOutlined as VisibilityOffOutlinedIcon } from "@mui/icons-material";
import { VisibilityOutlined as VisibilityOutlinedIcon } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";

interface Props {
  type?: "icon" | "button";
  areAllItemsExpanded: boolean;
  setAllItemsExpanded: (expanded: boolean) => void;
}

export const TreeToggleAllExpandedButton = ({
  areAllItemsExpanded,
  setAllItemsExpanded,
  type = "icon",
}: Props) => {
  const { t } = useTranslate("ItemTree");

  const getText = (state: boolean) => {
    switch (state) {
      case true:
        return t("Collapse all");
      case false:
        return t("Expand all");
    }
  };

  const getIcon = (state: boolean) => {
    switch (state) {
      case true:
        return <UnfoldLessIcon />;
      case false:
        return <UnfoldMoreIcon />;
    }
  };

  const toggleExpandedAll = () => {
    setAllItemsExpanded(!areAllItemsExpanded);
  };

  return type === "icon" ? (
    <Tooltip title={getText(areAllItemsExpanded)}>
      <IconButton
        style={{ width: 30, height: 30, flexShrink: 0, marginLeft: -3 }}
        onClick={toggleExpandedAll}
        size="small"
        color="primary"
      >
        {getIcon(areAllItemsExpanded)}
      </IconButton>
    </Tooltip>
  ) : type === "button" ? (
    <Button
      onClick={toggleExpandedAll}
      size="small"
      color="primary"
      variant="text"
      startIcon={getIcon(areAllItemsExpanded)}
    >
      {getText(areAllItemsExpanded)}
    </Button>
  ) : (
    <></>
  );
};

interface EliminatedItemsProps {
  type?: "icon" | "button";
  areEliminatedItemsShown: boolean;
  setEliminatedItemsShown: (shown: boolean) => void;
}

export const TreeToggleEliminatedItemsButton = ({
  areEliminatedItemsShown,
  setEliminatedItemsShown,
  type = "icon",
}: EliminatedItemsProps) => {
  const { t } = useTranslate("ItemTree");

  const getText = (shown: boolean) =>
    shown ? t("Hide eliminated items") : t("Show eliminated items");

  const getIcon = (shown: boolean) =>
    shown ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />;

  const toggleEliminatedItemsShown = () => {
    setEliminatedItemsShown(!areEliminatedItemsShown);
  };

  return type === "icon" ? (
    <Tooltip title={getText(areEliminatedItemsShown)}>
      <IconButton
        // 44×44 hit area for touch (the platform ships native apps); `size`
        // keeps the icon itself small.
        style={{ width: 44, height: 44, flexShrink: 0 }}
        onClick={toggleEliminatedItemsShown}
        size="small"
        color="primary"
        aria-label={getText(areEliminatedItemsShown)}
      >
        {getIcon(areEliminatedItemsShown)}
      </IconButton>
    </Tooltip>
  ) : type === "button" ? (
    <Button
      onClick={toggleEliminatedItemsShown}
      size="small"
      color="primary"
      variant="text"
      startIcon={getIcon(areEliminatedItemsShown)}
    >
      {getText(areEliminatedItemsShown)}
    </Button>
  ) : (
    <></>
  );
};
